import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import TestimonialsReportDetailedLayer from "../components/TestimonialsReportDetailedLayer";

const TestimonialsReportDetailedPage = () => {
    return (
        <MasterLayout>
            <TestimonialsReportDetailedLayer />
        </MasterLayout>
    );
};

export default TestimonialsReportDetailedPage;
